const retainedPostLogout = {
  showHorizontalScrollMessage: 'show_horizontal_scroll_message',
  allowedCookies: 'allowed_cookies',
  useMockData: 'use_mock_data',
  disableEnvironmentIndication: 'disable_environment_indication',
}

export const localStorageItemKeys = {
  notificationBanners: 'HideNotificationBanners',
  closedWelcomePopupVersion: 'closed_welcome_popup_version',
  emailSubscriptions: 'email_subscriptions',
  triggeredGuidedTour: 'triggered_guided_tour',
  guidedTourInitialStepIndex: 'guided_tour_initial_step_index',
  impersonate: 'impersonate',
  earningsValidation: 'earnings_validation',
  navigationAccordionState: 'nav-accordion-state',
  navigationIsOpen: 'navigation-is-open',
  dailyUpdatePopupClosed: 'daily_update_popup_closed',
  retainedPostLogout,
}
